import { isDev } from '@/config';
console.log('avalon:', isDev);
// 测试：
// AppID：wx8cb575a962ee070f
// 正式：
// wx63d0d5fd8601508d
const WXAPPID = isDev ? 'wx8cb575a962ee070f' : 'wx63d0d5fd8601508d';
const Midas = {
  /**
	 * 米大师h5支付（标准包月）
	 * https://wiki.midas.qq.com/post/index/1/40/29/0
	 * type:wx/qq
	 * ap:-1不显示自动续费
	 */

  // &pf=vip_m-midas_h5-html5-${source}-${type}

  payTemplate(type, serviceId, offerId, productId, openId, openKey, continousmonth, month, vipLevel) {
    console.log('location.href:', location.href);
    const callbackPath = encodeURIComponent(location.href +
			'paid' +
			'?pays=' +
			month +
			'&&user=' +
			vipLevel);// 返回按钮url
    console.log('callbackPath:', callbackPath);
    let template = `http://pay.qq.com/h5/index.shtml?m=buy
		&as=1
		&sandbox=${isDev ? 1 : ''}
		&service=${serviceId}
		&appid=${offerId}
		&productid=${productId}
		&openid=${openId}
		&ru=${callbackPath}
		&ap=-1
		&pu=history.back
		&hh=1
		&pf=1
		`;
    // QQ
    if (type == 'qq') {
      template += `
			&c=qqsubscribe
			&openkey=${openKey}
			&sessionid=openid
			&sessiontype=kp_actoken
			`;
    } else if (type == 'wx') {
      template += `
			&c=subscribe
			&sessionid=hy_gameid
			&sessiontype=wc_actoken
			&openkey=${openKey}
			&wxAppid2=${WXAPPID}		`;
    }
    if (continousmonth == 1) {
      template += '&continousmonth=1&cmn=1&sdkpay=1';
    }
    template = template.replace(/\n+\s+/gm, '');
    return template;
  }
};
export default Midas;
